'use client'

import { useTranslations } from 'next-intl'
import { useCookieConsent } from '@alvaromartinezreche98-svg/cookie-consent'

type Props = {
  className?: string
}

export default function CookieSettingsLink({ className }: Props) {
  const { openPreferences } = useCookieConsent()
  const t = useTranslations('cookies')

  return (
    <button
      type="button"
      onClick={openPreferences}
      className={className}
      style={{
        background: 'transparent',
        border: 0,
        padding: 0,
        font: 'inherit',
        color: 'inherit',
        textDecoration: 'underline',
        textUnderlineOffset: '0.2em',
        cursor: 'pointer',
        textTransform: 'inherit',
        letterSpacing: 'inherit',
      }}
    >
      {t('settingsLink')}
    </button>
  )
}
